import tracker from "./common/tracker"
import { SVG_URL } from "./common/constants"
import { defineMessages } from "react-intl"
// TO DO: TRANSLATION TECHNICAL DEBT: This was done as a quick way to keep
// track of translated text for react-intl under a very short deadline.
// Will likely need to refactor at some point and organize appropriately
export const messages = defineMessages({
  identifiersQuestion: {
      id: "identifiers.pov.question",
      defaultMessage: "Are you answering for yourself or someone else?",
  },
  identifiersOptionMe: {
    id: "identifiers.pov.options.myself",
    defaultMessage: "Me",
  },
  identifiersOptionSomeone: {
    id: "identifiers.pov.options.someoneelse",
    defaultMessage: "Someone else",
  },
  identifiersSexQuestionSelf: {
    id: "identifiers.sex.question.self",
    defaultMessage: "Are you a male or female?"
  },
  identifiersSexQuestionOther: {
    id: "identifiers.sex.question.other",
    defaultMessage: "Are they a male or female?"
  },
  identifiersSexWhy: {
    id: "identifiers.sex.why",
    defaultMessage: "Why not more options?"
  },
  identifiersSexWhyBody: {
    id: "identifiers.sex.why.body",
    defaultMessage: "We recognize that not everyone identifies as female or male, so we're working to incorporate more gender identities into Buoy's algorithm. For now, enter your sex at birth to continue."
  },
  identifiersSexWhyOkay: {
    id: "identifiers.sex.why.okay",
    defaultMessage: "Okay",
  },
  identifiersSexWhyCancel: {
    id: "identifiers.sex.why.cancel",
    defaultMessage: "Cancel",
  },
  identifiersSexOptionsMale: {
    id: "identifiers.sex.options.male",
    defaultMessage: "Male",
  },
  identifiersSexOptionsFemale: {
    id: "identifiers.sex.options.female",
    defaultMessage: "Female",
  },
  identifiersAgeQuestion: {
    id: "identifiers.age.question",
    defaultMessage: "How old are you?",
  },
  identifiersAgeQuestionHe: {
    id: "identifiers.age.question.he",
    defaultMessage: "How old is he?",
  },
  identifiersAgeQuestionShe: {
    id: "identifiers.age.question.she",
    defaultMessage: "How old is she?",
  },
  identifiersAgeField: {
    id: "identifiers.age.field",
    defaultMessage: "years old",
  },
  identifiersAgeResponse: {
    id: "identifiers.age.response",
    defaultMessage: "{age} years old",
  },
  identifiersAgeSubmit: {
    id: "identifiers.age.submit",
    defaultMessage: "Submit",
  },
  identifiersAgeAlert: {
    id: "identifiers.age.alert",
    defaultMessage: "Must be between 13 and 120",
  },
  identifiersAgeAlertOther: {
    id: "identifiers.age.alert.other",
    defaultMessage: "Must be between 2 and 120",
  },
  identifiersAgeTooltip: {
    id: "identifiers.age.tooltip",
    defaultMessage: "Buoy Assistant is designed to consult on symptoms for patients between the ages of 13 and 120.",
  },
  identifiersAgeTooltipOther: {
    id: "identifiers.age.tooltip.other",
    defaultMessage: "Buoy Assistant is designed to consult on symptoms for patients between the ages of 2 and 120.",
  },
  identifiersAgeWhy: {
    id: "identifiers.age.why",
    defaultMessage: "Why am I being asked this?",
  },
  identifiersAgeWhyBody: {
    id: "identifiers.age.why.body",
    defaultMessage: "Many illnesses only affect certain age groups. Knowing your age allows Buoy to give a more accurate assessment.",
  },
  interviewMessagesBeginning: {
    id: "interview.messages.beginning",
    defaultMessage: "Alright. Let's figure this out together.",
  },
  interviewMessagesMiddle: {
    id: "interview.messages.middle",
    defaultMessage: "Making progress. Let’s cover a few more symptoms.",
  },
  interviewMessagesEnd: {
    id: "interview.messages.end",
    defaultMessage: "Almost there. Just covering all the bases.",
  },
  interviewQuestionsSymptom: {
    id: "interview.questions.symptom",
    defaultMessage: "What symptom is bothering you the most?",
  },
  interviewQuestionsSymptomF: {
    id: "interview.questions.symptom.f",
    defaultMessage: "What symptom is bothering her the most?",
  },
  interviewQuestionsSymptomM: {
    id: "interview.questions.symptom.m",
    defaultMessage: "What symptom is bothering him the most?",
  },
  interviewMessagesCoronaSymptoms: {
    id: "interview.messages.corona.symptoms",
    defaultMessage: "Got it.",
  },
  interviewMessagesCoronaIdentifiers: {
    id: "interview.messages.corona.identifiers",
    defaultMessage: "I also need to factor in a couple of quick details.",
  },
  completionDisclaimer: {
    id: "completion.disclaimer",
    defaultMessage: "Here’s what may be going on. Remember, this isn’t meant to replace professional medical advice, diagnosis, or treatment.",
  },
  preintentQuestion: {
    id: "preintent.question",
    defaultMessage: "Are you thinking about seeing a medical professional for this?",
  },
  preintentQuestionThey: {
    id: "preintent.question.they",
    defaultMessage: "Are they thinking about seeing a medical professional for this?",
  },
  preintentOptionConfirm: {
    id: "preintent.option.confirm",
    defaultMessage: "Yes",
  },
  preintentOptionDeny: {
    id: "preintent.option.deny",
    defaultMessage: "No",
  },
  preintentQuestionType: {
    id: "preintent.question.type",
    defaultMessage: "What care are you considering?",
  },
  preintentQuestionTypeThey: {
    id: "preintent.question.type.they",
    defaultMessage: "What care are they considering?",
  },
  preintentOptionNota: {
    id: "preintent.option.nota",
    defaultMessage: "None of the above"
  },
  interviewMessageFilter: {
    id: "interview.message.filter",
    defaultMessage: "Great. Now back to your {symptom}",
  },
  interviewMessageFilterNext: {
    id: "interview.message.filter.next",
    defaultMessage: "Let’s talk about your next symptom."
  },
  interviewMessagesConclusionsAllSet: {
    id: "interview.messages.conclusions.allset",
    defaultMessage: "All set. Preparing your symptom report."
  },
  interviewMessagesConclusions: {
    id: "interview.messages.conclusions",
    defaultMessage: "Preparing conclusions now..."
  }
})

export const BUOY_BRAND = {
  color: "#00ADEF",
  name: "Buoy Health",
  icon: `${SVG_URL}chat_buoy_icon.svg`,
}

/*
Chat item generation functions moved here to better organize store code
and to ensure that if any change, they are changed in one location. If any of
these are added to the chatItems list, they should be passed through
store.addChatItem to ensure any additional necessary properties are attached
*/
export const searchQuestion = (first, pov, sex) => ({
         type: "search",
         text: first
           ? pov === "self"
             ? messages.interviewQuestionsSymptom
             : sex === "male"
             ? messages.interviewQuestionsSymptomM
             : messages.interviewQuestionsSymptomF
           : "What else is wrong?",
         inputType: "search",
         options: [],
         response: [],
         link: "/completion/#treatment",
       })

export const symptomBubble = (first = false, text, embedded) => ({
  type: "symptomBubble",
  first,
  text,
  embedded,
})

export const interviewQuestion = ({
  question_text,
  token,
  question_type,
  options,
  filter,
  preselected,
  dgn,
  predInfoLists,
  media,
  qtoken,
  question_context,
}) => {
  let response = []

  return {
    type: "question",
    text: question_text,
    token,
    inputType: questionTypes[question_type],
    options,
    response: question_type === "D" && !filter ? [options[0]] : response,
    filter,
    dgn,
    image: media,
    blur: true,
    predInfoLists,
    duration: question_type === "D" ? { unit: "days", amount: "1" } : null,
    preselected,
    qtoken,
    question_context,
  }
}

export const screeningQuestion = ({
  text,
  options,
  failFast,
  number,
  clientCode,
}) => ({
  type: "screeningQuestion",
  text,
  options,
  inputType: "radio",
  number,
  failFast,
  clientCode,
  response: [],
})

export const screeningScreenOutQuestion = ({ text, options }) => ({
  type: "screeningScreenOutQuestion",
  text,
  options,
  inputType: "radio",
  response: [],
})

export const image = image => ({
  type: "image",
  text: "",
  image: image,
})

export const systemMessage = (text, link, linkText) => ({
  type: "message",
  text,
  link,
  linkText,
})

export const temporaryMessage = text => ({
  type: "temporaryMessage",
  text,
})

export const diagnosis = ({ diagnosis }) => ({
  type: "diagnosis",
  text: diagnosis,
})

export const response = (text, isFeedback) => ({
  type: "response",
  text: text,
  isFeedback: isFeedback,
})

export const clarifier = (clarifier, isFirst, custom) => ({
  type: "clarifier",
  text:
    custom.clarifier && isFirst ? custom.clarifier : clarifier.question_text,
  inputType: "checkbox",
  response: [],
  options: clarifier.options,
  groupId: clarifier.groupId,
})

export const feedback = (text, inputType, options) => ({
  type: "feedback",
  text: text,
  inputType: inputType,
  response: [],
  options: options,
})

export const integrationPrompt = () => ({
  type: "integrationPrompt",
  text:
    "I see you might need care. Would you like to view doctors in your area?",
  inputType: "radio",
  response: [],
  options: [
    { text: "Show me options nearby", token: "Yes" },
    { text: "No thanks", token: "No" },
  ],
})

export const location = (initial = []) => ({
  type: "location",
  text: "To provide most relevant services, we'll need your current location.",
  inputType: "location",
  response: initial,
  options:
    "geolocation" in navigator
      ? [{ text: "Find my location automatically", token: "auto" }]
      : [],
})

export const membership = options => ({
  type: "membership",
  text: "Are you a member of any of the following health care organizations?",
  inputType: "checkbox",
  response: [],
  options: options,
})

export const integrationSelect = options => ({
  type: "integrationSelect",
  text:
    "Given your preferences, the following healthcare services would " +
    "love to help with your situation:",
  inputType: "integration",
  response: [],
  options: options,
})

export const integrationQues = ques => ({
  type: "integrationQues",
  text: ques.text,
  link: ques.link,
  linkText: ques.link,
  quesType: ques.ques_type,
  options: ques.options,
  response: [],
  inputType: questionTypes[ques.ques_type],
  brand: ques.brand,
})

export const identityQues = (profiles, isAnonymous) => {
  let selfOpt = { text: messages.identifiersOptionMe, token: "self", pov: "self" }
  let options = []
  if (profiles) {
    profiles.forEach(profile => {
      let sex = profile.sex === "m" ? "male" : "female"
      if (profile.isself)
        selfOpt = {
          text: messages.identifiersOptionMe,
          token: profile.first_name,
          pov: "self",
          sex,
          age: profile.age,
          id: profile.id,
        }
      else
        options.push({
          text: profile.first_name,
          token: profile.first_name,
          pov: "other",
          sex,
          age: profile.age,
          id: profile.id,
        })
    })
  }
  options.unshift(selfOpt)
  options.push({ text: messages.identifiersOptionSomeone, token: "other", pov: "other" })

  return {
    type: "identity",
    text: messages.identifiersQuestion,
    inputType: "radio",
    options: options,
    response: [],
  }
}

export const sexQues = pov => ({
  type: "sex",
  text:
    pov === "self"
      ? messages.identifiersSexQuestionSelf
      : messages.identifiersSexQuestionOther,
  inputType: "radio",
  options: [
    { text: messages.identifiersSexOptionsMale, token: "male" },
    { text: messages.identifiersSexOptionsFemale, token: "female" },
  ],
  response: [],
})

export const ageQues = (pov, sex) => ({
  type: "age",
  text:
    pov === "self"
      ? messages.identifiersAgeQuestion
      : sex === "male"
      ? messages.identifiersAgeQuestionHe
      : messages.identifiersAgeQuestionShe,
  inputType: "age",
  options: [],
  response: [],
})

export const nameQues = (pov, sex) => ({
  type: "name",
  text: `How would ${
    pov === "self" ? "you" : sex === "male" ? "he" : "she"
  } like to be addressed?`,
  inputType: "text",
  placeholder: "First name",
  options: [],
  response: [],
})

export const emailQues = () => ({
  text: "Please provide your contact information so we can send you a copy.",
  type: "email",
  inputType: "email",
  options: [],
  response: [],
})

export const adjusting = () => ({
  type: "adjusting",
})

export const share = shareInfo => ({
  type: "share",
  text: shareInfo.header,
  shareInfo: shareInfo,
})

export const badRatingFollowup = () => ({
  type: "ratingQues",
  text: "What was frustrating to you (select as many as you want)?",
  options: [
    { text: "The results are inaccurate", token: "The results are inaccurate" },
    { text: "Too many questions", token: "Too many questions" },
    {
      text: "The questions are confusing",
      token: "The questions are confusing",
    },
    { text: "Answer options are missing", token: "Answer options are missing" },
  ],
  response: [],
  inputType: "checkbox",
})

export const error = msg => ({
  type: "error",
  text: msg,
})

const commaSep = list => {
  return [list.slice(0, -1).join(", "), list.slice(-1)[0]].join(
    list.length < 2 ? "" : " or "
  )
}

export const completionOpener = diagnoses => {
  let pos_lab = diagnoses.filter(d => d.test_req).map(d => d.diagnosis)
  let neg_lab = diagnoses.filter(d => !d.test_req).map(d => d.diagnosis)
  let text = `Based on your symptoms, we suspect ${
    diagnoses.length
  } possible explanation${diagnoses.length > 1 ? "s" : ""}:`

  switch (pos_lab.length) {
    case 0:
      text = `${text} ${commaSep(neg_lab)}.`
      break
    case 1:
      if (neg_lab.length) {
        text = `${text} It could be ${commaSep(neg_lab)}. Or it could be ${
          pos_lab[0]
        }, which would require lab testing to identify.`
      } else {
        text = `${text} It could be ${pos_lab[0]}, which would require lab testing to identify.`
      }
      break
    case 2:
      if (neg_lab.length) {
        text = `${text} It could be ${commaSep(neg_lab)}. It could also be ${
          pos_lab[0]
        }, which would require lab testing to identify. Or it could be ${
          pos_lab[1]
        }, which would require lab testing to identify.`
      } else {
        text = `${text} It could be ${pos_lab[0]}, which would require lab testing to identify. Or it could be ${pos_lab[1]}, which would require lab testing to identify.`
      }
      break
    case 3:
      text = `${text} ${commaSep(neg_lab)}. All ${
        neg_lab.length
      } of these would require lab testing to identify.`
      break
    default:
      text = ""
  }

  return systemMessage(text)
}

export const completion = () => ({
  type: "completion",
})

export const emptyCompletion = () => ({
  type: "emptyCompletion",
})

export const intentSeekingCare = pov => ({
  type: "intentSeekingCare",
  text:
    pov === "self"
      ? messages.preintentQuestion
      : messages.preintentQuestionThey,
  inputType: "radio",
  options: [
    { text: messages.preintentOptionConfirm, token: 1 },
    { text: messages.preintentOptionDeny, token: 0 },
  ],
  response: [],
})

export const intentCareOptions = (pov, options) => ({
  type: "intentCareOptions",
  text:
    pov === "self"
      ? messages.preintentQuestionType
      : messages.preintentQuestionTypeThey,
  inputType: "radio",
  options: options,
  response: [],
})

export const specialistIntentCareOptions = options => ({
  type: "specialistIntentCareOptions",
  text: "What type of specialist care?",
  inputType: "radio",
  options: options,
  response: [],
})

export const specialistSelect = () => ({
  type: "specialistIntentCareOptions",
  inputType: "specialist",
  response: [],
  placeholder: "Search for a specialist",
  skipText: "Skip",
  noIcon: true,
})

export const diagnosisConcern = noFocus => ({
  type: "diagnosisConcern",
  inputType: "diagnosis",
  response: [],
  placeholder: "Search for a diagnosis",
  skipText: "Skip",
  noFocus,
  noIcon: true,
})

export const preparingResults = brand =>
  systemMessage(
    brand.visit_chat &&
      brand.visit_chat.settings &&
      !brand.visit_chat.settings.skip_collection
      ? messages.interviewMessagesConclusionsAllSet
      : messages.interviewMessagesConclusions
  )

export const resultsDisclaimer = () => systemMessage(messages.completionDisclaimer)

export const zipcodePrompt = () =>
  systemMessage("We may have some care options near your area...")

export const insuranceCapture = () => ({
  type: "insuranceCapture",
  text: "What is your current health insurance?",
  inputType: "radio",
  options: [
    // TODO: Names are hacky here but since PlanProviders don't have an order attached,
    // we have to use them as keys to actual planprovider token pairs.
    { text: "Blue Cross Blue Shield (BCBS)", token: "Blue Cross Blue Shield" },
    { text: "UnitedHealthcare (UHC)", token: "UnitedHealthcare" },
    { text: "Cigna", token: "Cigna" },
    { text: "Other", token: "Other" },
    { text: "Not insured", token: "Not Insured" },
    { text: "Skip", token: "Other" },
  ],
})

export const employerCaptureIntro = () => ({
  type: "employerCaptureIntro",
  text:
    "Do you receive health insurance through an employer (either yours or that of a family member)?",
  inputType: "radio",
  options: [
    { text: "Yes", token: "Yes" },
    { text: "No", token: "No" },
    { text: "Skip", token: "Skip" },
  ],
})

export const employerCaptureInput = () => ({
  type: "employerCaptureInput",
  text:
    "Great! Let’s find out if they’re in the Buoy network. What’s the employer’s name?",
  inputType: "employer",
  placeholder: "Employer name",
  skipText: "Skip",
})

export const initItems = (profiles, isAnonymous) => {
  tracker.pageLoaded()
  return [identityQues(profiles, isAnonymous)]
}

export const questionTypes = {
  M: "checkbox",
  S: "radio",
  D: "duration",
}

// dxoc = diagnosis of concern
export const dxocClose = (dxoc, contentPage) => ({
  type: "dxocCloseMessage",
  dxoc: dxoc,
  link: contentPage,
})

export const dxocPromptQuestion = pov => ({
  type: "dxocPromptQuestion",
  text: `Is there a specific diagnosis ${
    pov === "self" ? "you" : "they"
  } are wondering about?`,
  inputType: "radio",
  options: [
    { text: "Yes", token: 1 },
    { text: "No", token: 0 },
  ],
  response: [],
})



// WEBPACK FOOTER //
// ./assets/chatItemGenerator.js